const cleanChar775 = inputString => {
	if (!inputString) {
		return inputString;
	}

	// Initialize an empty string to store the cleaned string
	let cleanedString = '';

	// Iterate through each character in the input string
	for (let i = 0; i < inputString.length; i++) {
		// Check if the character's char code is not equal to 775
		if (inputString.charCodeAt(i) !== 775) {
			// Append the character to the cleaned string
			cleanedString += inputString[i];
		}
	}

	// Return the cleaned string
	return cleanedString;
};

export { cleanChar775 };
